<template>
  <v-row justify="center">
    <v-col cols="auto">
      <v-dialog transition="dialog-bottom-transition"  v-model="dialogus" max-width="700">
        <template >

        </template>
        <template >
          <v-card>

            <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col
        cols="12"
        md="4"
      >
        <single-article v-if="tohide"
              :ref="'article_' + describme.id"
              @getbackitems="sommeofquantitiesEmetedTokiosk"
              @maxamountnotif="showmaxamountnotifEmetedTokiosk"
              :details="describme"
              :current_quantity="describme.current_quantity"
              md="4"
              :redirect="redirect"
            >
            </single-article>
            <v-img
      :src="redirect + '/public' + describme.image"
      :lazy-src="describme.image"
      aspect-ratio="1"
      class="grey lighten-2"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
      >
             <v-card-title> {{describme.title}} </v-card-title>

             <v-card-text >
               <div style="color:#2a1e14 !important" v-html="describme.description"></div>
             </v-card-text>

      </v-col>
<v-col
        cols="12"
        sm="12"
        md="12"
      >
      <v-carousel v-if="describme.carousel && describme.carousel.length">
      <v-carousel-item
        v-for="(item, index) in describme.carousel"
        :key="index"
        :src="item"
        cover
      ></v-carousel-item>
    </v-carousel>
      </v-col>

    </v-row>
  </v-container>





            <v-card-actions class="justify-end">
              <v-btn text @click="dialogus = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import Article from "./article.vue";

export default {
  title: "DescriptionArticle",
  components: {
    "single-article": Article
  },
  props: {
    describme: Object,
    redirect: String
  },
  data() {
    return {
      dialogus :false,
      tohide:false
    };
  },
  watch: {
    describme(datadescription){

        console.log('detection de changemenet description',datadescription);
        this.dialogus = true;

    }
  },
  methods: {
    sommeofquantitiesEmetedTokiosk(quantity) {
      this.$emit("getbackitemsFromDescription", quantity);
    },
    showmaxamountnotifEmetedTokiosk(maxamount) {
      this.$emit("maxamountnotifFromDescription", maxamount);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pieces/descriptionarticle.vue